import { render, staticRenderFns } from "./fluxo-de-caixa.vue?vue&type=template&id=2afabbb6&"
import script from "./fluxo-de-caixa.vue?vue&type=script&lang=js&"
export * from "./fluxo-de-caixa.vue?vue&type=script&lang=js&"
import style0 from "./fluxo-de-caixa.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports